import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  input,
  linkedSignal,
  ViewEncapsulation,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { isArray, isBoolean, isNumber, isObject, isString } from '../utils/utils';
import { ExpansionState } from '../json-view/json-view.component';

@Component({
  selector: 'ct-extraction-nxt-json-view-item',
  templateUrl: './json-view-item.component.html',
  styleUrls: ['./json-view-item.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  imports: [NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JsonViewItemComponent {
  readonly data = input.required<unknown>();

  readonly key = input<string>();
  readonly level = input(0);
  readonly expansionState = input<ExpansionState>();

  readonly isOpen = linkedSignal(() => {
    const state = this.expansionState();
    if (!state) return false;

    if (state.type === 'expandedTo') return state.level >= this.level();
    return state.level < this.level();
  });

  readonly childrenKeys = computed(() =>
    isObject(this.data()) ? Object.keys(this.data() as object) : undefined,
  );

  readonly hasChildren = computed(() => !!this.childrenKeys()?.length);

  dataType?: string;
  value: unknown;
  valueType?: string;
  isObject = false;
  isArray = false;

  _ = effect(() => this.setupDataType());

  setupDataType() {
    if (isObject(this.data())) {
      this.isObject = true;
      this.dataType = 'Object';
      if (isArray(this.data())) {
        this.isArray = true;
        this.dataType = 'Array';
      }
    } else {
      this.value = this.data();
      if (isString(this.data())) {
        this.valueType = 'string';
      } else if (isNumber(this.data())) {
        this.valueType = 'number';
      } else if (isBoolean(this.data())) {
        this.valueType = 'boolean';
      } else if (null === this.data()) {
        this.valueType = 'null';
        this.value = 'null';
      }
    }
  }

  toggle() {
    if (this.hasChildren()) {
      this.isOpen.set(!this.isOpen());
    }
  }

  protected getDataChild(key: string) {
    return (this.data() as Record<string, unknown>)[key];
  }
}
